var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3242_1551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4496 49.8671C33.403 49.2917 34.5967 49.2917 35.55 49.8671L45.4229 55.826C47.6948 57.1972 50.4975 55.1603 49.8946 52.576L47.2746 41.3449C47.0216 40.2604 47.3901 39.125 48.2318 38.3959L56.959 30.8355C58.9648 29.0979 57.8926 25.8031 55.2483 25.5788L43.7641 24.6044C42.6554 24.5104 41.6898 23.8104 41.2556 22.7859L36.762 12.1836C35.7282 9.74452 32.2715 9.74453 31.2377 12.1836L26.7441 22.7859C26.3099 23.8104 25.3443 24.5104 24.2356 24.6044L12.7514 25.5788C10.1071 25.8031 9.03489 29.0979 11.0407 30.8355L19.7679 38.3959C20.6096 39.125 20.9781 40.2604 20.7251 41.3449L18.1051 52.576C17.5022 55.1603 20.3049 57.1972 22.5768 55.826L32.4496 49.8671Z",
    fill: "#FFC303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3242_1551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.96d7b327adc8dbb419454d16ba37e962.svg";
export { ForwardRef as ReactComponent };